import * as React from "react";
const ModernEndCallIcon = (props) => (
  <svg
    width={21}
    height={10}
    viewBox="0 0 21 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0.718407 7.25C0.550279 6.91267 0.47697 6.536 0.506314 6.16023C0.535658 5.78447 0.666552 5.42374 0.885007 5.1166C1.95397 3.54934 3.38736 2.26496 5.06209 1.37374C6.73682 0.482531 8.60284 0.0111225 10.4999 0C12.397 0.0111113 14.263 0.482505 15.9377 1.3737C17.6124 2.2649 19.0458 3.54926 20.1148 5.1165C20.3333 5.42364 20.4642 5.78437 20.4935 6.16013C20.5228 6.5359 20.4495 6.91257 20.2814 7.2499L19.1985 9.4274C19.1385 9.54881 19.0551 9.65716 18.9531 9.74622C18.8511 9.83528 18.7325 9.90329 18.6041 9.94633C18.4757 9.98937 18.3401 10.0066 18.205 9.99701C18.0699 9.98743 17.938 9.95123 17.817 9.8905L15.1882 8.5689C15.0168 8.48245 14.8729 8.35008 14.7724 8.18657C14.6719 8.02306 14.6188 7.83483 14.619 7.6429L14.4999 5C14.4999 5 13.5892 3.106 10.4999 3.106C7.41061 3.106 6.49991 5 6.49991 5L6.38081 7.6429C6.38105 7.83483 6.32795 8.02306 6.22745 8.18657C6.12694 8.35008 5.98297 8.48245 5.81161 8.5689L3.18281 9.8905C3.06177 9.95123 2.92992 9.98743 2.79484 9.99701C2.65976 10.0066 2.52412 9.98937 2.39572 9.94633C2.26733 9.90329 2.14871 9.83528 2.04669 9.74622C1.94468 9.65716 1.86129 9.54881 1.80131 9.4274L0.718407 7.25Z"
      fill="white"
    />
  </svg>
);
export default ModernEndCallIcon;
